import request from '@utils/request'

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login (data) {
  return request.post('/da_login', data, { login: false })
}

/*
 * 用户信息
 */
export function getUserInfo () {
  return request.get('/da_userinfo', {}, { login: true })
}

/*
 * 退出登录
 * */
export function logout() {
  return request.post("/auth/da_logout")
}
